import { Box, Flex, styled, StyleSystemProps } from '@withjoy/joykit';

export const StyledSkeletonFilterHeader = styled(Box)``;
export const StyledSkeletonFilterItemContainer = styled(Flex)``;
export const StyleFacetListContainer = styled(Box)``;

const filterHeaderStyle: StyleSystemProps = {
  typographyVariant: 'hed2'
};

const subtotalFiltersStyle: StyleSystemProps = {
  size: 6,
  backgroundColor: 'black',
  borderRadius: '100%',
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white'
};

const accordionIconStyle: StyleSystemProps = {
  size: 6,
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'black'
};

const filterHeaderStyles: StyleSystemProps = {};
const accordionButtonStyles: StyleSystemProps = {
  paddingX: '2rem',
  paddingY: '1rem',
  height: '56px',
  pointerEvents: 'auto',
  width: '100%',
  borderRadius: '28px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  backgroundColor: 'white',
  _hover: {
    backgroundColor: 'gray2'
  }
};

const filterItemContainerStyles: StyleSystemProps = {
  paddingLeft: '2rem',
  flexDirection: 'row',
  paddingY: 2
};

const facetListContainerStyles: StyleSystemProps = {
  padding: 5
};

export const styles = {
  listContainer: facetListContainerStyles,
  filterHeader: filterHeaderStyles,
  filterItemContainer: filterItemContainerStyles,
  accordionButton: accordionButtonStyles,
  filterHeaderStyle,
  subtotalFiltersStyle,
  accordionIconStyle
};
